@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';

.wrapper {
  display: flex;
  gap: @space-24;
}

.root {
  position: relative;
  box-sizing: content-box;
  border: 1px solid var(--grey-300);
  background-color: var(--grey-000);
  background-image:
    linear-gradient(to right, hsl(220, 7%, 92%) 1px, transparent 1px), linear-gradient(to bottom, hsl(220, 7%, 92%) 1px, transparent 1px);
}

.root--selected {
  border-color: var(--blue-600);
}
